import { Button, Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { formatCurrency } from './eventDetailsUtils';
import { registrationStyles } from './eventDetailsStyles';

const RegistrationSummary = ({
  session,
  selectedTicket,
  selectedTicketSeatsLeft,
  quantity,
  totalPrice,
  disabled,
  onConfirm,
}) => (
  <Box sx={registrationStyles.summaryPanel}>
    <Typography variant="subtitle2" sx={{ fontWeight: 900, mb: 1.5 }}>
      Registration Summary
    </Typography>

    <Grid container spacing={2}>
      {/* Row 1 - Session/Ticket, Quantity, Total */}
      <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Box>
            <Typography variant="caption" color="text.secondary">
              Session
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 800 }}>
              {session.title}
            </Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="text.secondary">
              Ticket
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 800 }}>
              {selectedTicket
                ? `${selectedTicket.label}${
                    selectedTicketSeatsLeft !== null
                      ? ` (${selectedTicketSeatsLeft} left)`
                      : ''
                  }`
                : 'Choose a ticket'}
            </Typography>
          </Box>
        </Box>
      </Grid>

      <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}>
        <Typography variant="caption" color="text.secondary">
          Quantity
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 800 }}>
          {quantity}
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}>
        <Typography variant="caption" color="text.secondary">
          Total Amount
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 900 }}>
          {formatCurrency(totalPrice)}
        </Typography>
      </Grid>

      {/* Row 2 - Centered CTA */}
      <Grid size={{ xs: 12 }} sx={{ display: { xs: 'none', md: 'block' } }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: 2,
          }}
        >
          <Button
            variant="contained"
            disabled={disabled}
            onClick={onConfirm}
            sx={registrationStyles.confirmButton}
          >
            Confirm &amp; Continue
          </Button>
        </Box>
      </Grid>
    </Grid>
  </Box>
);

export default RegistrationSummary;